import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { IAsignatura, IDocente, IResRegistroCalificaciones, ITablaBody, ITablaBodyRow, ITablaCalificaciones, ITablaHeaders } from 'src/app/interfaces/calificaciones';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { RegistroCalificacionesService } from 'src/app/services/registro-calificaciones/registro-calificaciones.service';
import { UtilsFnService } from 'src/app/services/utils/utils-fn.service';
import { WebSocketService } from 'src/app/services/web-socket/web-socket.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ingreso-calificacion',
  templateUrl: './ingreso-calificacion.component.html',
  styleUrls: ['./ingreso-calificacion.component.scss']
})
export class IngresoCalificacionComponent {
  dataSeleccion: any = []
  tablaCalificaciones: ITablaCalificaciones | null = null
  asignatura: IAsignatura | null = null
  docentes: IDocente[] = []
  infoModalTitulo: string = ''
  infoModalTexto: string = ''
  alertaExito: string = ''
  configuracion: any
  showDetail: boolean = false

  configuracionFiltros: any = {}
  registrosModificados: boolean = false

  nombreRutAlumnoFiltro: string = ''
  registrosEditables: boolean = false

  loadingAutoguardado: boolean = false
  tipoNotasReq = ['CP', 'CE', 'EX', 'AN']

  private intervalEstadoAlumnos: any;

  eventoNotasSubscription: Subscription | null = null;
  eventoEstadoAlumnosSubscription: Subscription | null = null;

  arrNotasPorEnviar: any = []
  loadingSocket: boolean = false;

  constructor(
    private router: Router,
    private _registroCalificaciones: RegistroCalificacionesService,
    private _utilsFn: UtilsFnService,
    private spinner: NgxSpinnerService,
    private webSocketService: WebSocketService,
    private _perfilamiento: PerfilamientoService
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( routerData?.dataSeleccion && routerData?.tablaCalificaciones && routerData?.configuracion ) {
      this.dataSeleccion = routerData.dataSeleccion
      this.tablaCalificaciones = routerData.tablaCalificaciones
      this.asignatura = routerData?.asignatura
      this.docentes = routerData?.docentes
      this.configuracion = routerData?.configuracion
      this.registrosEditables = routerData?.editable
    } else {
      this.router.navigate(['/portal-calificacion'])
    }

    if (routerData?.filtros) {
      this.configuracionFiltros = routerData.filtros;
    }

    window.addEventListener('online', () => {
      this.conexionSocket()
      // Validar que hacer en ingreso calificaciones cuando esta online/offline
      // this.obtenerCalificaciones()
    });
    window.addEventListener('offline', ()=> {
      this.router.navigate(['/portal-calificacion'])
    });
  }

  ngOnInit(): void {
    this.conexionSocket()

    this.webSocketService.connectionStatus$.subscribe((status: string) => {
      if ( status === 'closed' || status === 'error' || status === 'disconnected' ) {
        this.loadingSocket = true
        this.spinner.show()
      } else {
        if ( this.loadingSocket ) {
          this.loadingSocket = false
          this.spinner.hide()
          this.reenviarNotasPendientes()
        }
      }
    })

    this.intervalEstadoAlumnos = setInterval(() => {
      this.sendSocketInfoEstadoAlumnos()
    }, (environment.tiempoSocketEstadoAlumnos * 1000));
  }

  conexionSocket() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId
    }
    this.webSocketService.initializeWebSocketConnection(websocketParams)
    this.eventoNotasSubscription = this.webSocketService.eventoNota$.subscribe((event: any) => {
      this.modificarNotaDesdeSocket(event)
    });

    this.eventoEstadoAlumnosSubscription = this.webSocketService.eventoEstadoAlumnosObs$.subscribe((event: any) => {
      this.modificarEstadoAlumnoDesdeSocket(event)
    });
  }

  modificarNotaDesdeSocket(event: any){
    if ( event.indexRow && event.indexBody ) {
      this.tablaCalificaciones!.body[event.indexBody].row[event.indexRow].valor = event.valor
      this.tablaCalificaciones!.body[event.indexBody].row[event.indexRow].nuevoValor = event.valor
    } else {
      const alumnoFiltrado = this.tablaCalificaciones?.body.find((alumno: ITablaBody) => alumno.alumnoId === event.alumnoId && alumno.idCs === event.idCs)
      if ( alumnoFiltrado ) {
        alumnoFiltrado.row.forEach((alumnoRow: ITablaBodyRow) => {
          if ( alumnoRow.tipoNota === event.tipoNota && alumnoRow.nroNota === event.nroNota ) {
            alumnoRow.valor = event.valor
            alumnoRow.nuevoValor = event.nuevoValor
          }
        })
      }
    }
    this.validarListaNotas(event)
  }

  validarListaNotas(notaDesdeSocket: any) {
    const indexNota = this.arrNotasPorEnviar.findIndex((nota: any) => 
      nota.alumnoId === notaDesdeSocket.alumnoId &&
      nota.idCs === notaDesdeSocket.idCs &&
      nota.tipoNota === notaDesdeSocket.tipoNota &&
      nota.nroNota === notaDesdeSocket.nroNota
    )
    if (indexNota !== -1) {
      this.arrNotasPorEnviar.splice(indexNota, 1);
    }
  }

  reenviarNotasPendientes() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId
    }
    this.arrNotasPorEnviar.forEach((nota: any) => {
      let message = JSON.stringify(nota)
      this.webSocketService.sendMessage(websocketParams, message)
    });
  }

  modificarEstadoAlumnoDesdeSocket(event: any) {
    if ( event.alumnos ) {
      this.tablaCalificaciones?.body.forEach((alumno: ITablaBody) => {
        const alumnoEventFilter: any = event.alumnos.find((alumnoEvent: any) => alumno.alumnoId === alumnoEvent.alumnoId && alumno.idCs === alumnoEvent.idCs )
        if ( alumnoEventFilter ) {
          alumno.situacionFinal = alumnoEventFilter.situacionFinal
          alumno.row[alumno.row.length - 2].valor = alumnoEventFilter.situacionFinal

          if ( alumnoEventFilter.situacionFinal === 'RI' || alumnoEventFilter.situacionFinal === 'PP' ) {
            this.habilitarCpCeExSocket(alumno, false)
          } else {
            this.habilitarCpCeExSocket(alumno)
          }
        }
      })  
    }
  }

  sendSocketInfo(indexBody: number, row: any, i: number) {
    const idDocente: number | null = this._perfilamiento.getUsuario().tipoUsuario === 'Backoffice' ? this.configuracionFiltros?.dataDocente?.funcionarioId : null
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId
    }
    const dataAlumno: any = this.tablaCalificaciones?.body[indexBody]
    let nota = {
      "alumnoId": dataAlumno.alumnoId,
      "idCs": dataAlumno.idCs,
      "valor": row.valor,
      "nuevoValor": row.nuevoValor,
      "tipoNota": row.tipoNota,
      "nroNota": row.nroNota,
      "indexBody": indexBody,
      "indexRow": i,
      "docenteId": idDocente
    };
    let message = JSON.stringify(nota)
    this.arrNotasPorEnviar = [...this.arrNotasPorEnviar, nota]
    this.webSocketService.sendMessage(websocketParams, message)
  }

  sendSocketInfoEstadoAlumnos() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId
    }
    let estadoAlumnosArr: any = []
    this.tablaCalificaciones?.body.forEach((alumno: any) => {
      estadoAlumnosArr = [
        ...estadoAlumnosArr, 
        {
          alumnoId: alumno.alumnoId,
          idCs: alumno.idCs,
          situacionFinal: alumno.situacionFinal
        }
      ]
    });
    let message = JSON.stringify({alumnos: estadoAlumnosArr})
    this.webSocketService.sendEstadosAlumnos(websocketParams, message)
  }

  habilitarCpCeExSocket(alumnoFiltrado: any, habilitar: boolean = true) {
    alumnoFiltrado.row.forEach((filaAlumnoFiltrado: ITablaBodyRow) => {
      if ( filaAlumnoFiltrado.tipoNota ) {
        alumnoFiltrado.editable = habilitar
        filaAlumnoFiltrado.editable = habilitar
        if ( !habilitar && filaAlumnoFiltrado.tipoNota !== 'AN' ) {
          filaAlumnoFiltrado.valor = '0,0'
          filaAlumnoFiltrado.nuevoValor = '0,0'
        } else if (filaAlumnoFiltrado.tipoNota === 'AN') {
          filaAlumnoFiltrado.valor = ''
          filaAlumnoFiltrado.nuevoValor = ''
        }
        this.registrosModificados = false
      }
    })
  }

  ngOnDestroy() {
    clearInterval(this.intervalEstadoAlumnos)
    this.webSocketService.disconnect()
  }

  toggleDetail() {
    this.showDetail = !this.showDetail
  }

  volverAPortal(): void {
    if ( this.registrosModificados ) {
      document.getElementById('modal-cambios-pendientes-close')?.click()
    }
    this.router.navigate(['/seleccion-calificacion'], {
      state: {
        data: {
          tablaCalificaciones: this.tablaCalificaciones,
          configuracion: this.configuracion,
          filtros: this.configuracionFiltros,
          asignatura: this.asignatura,
          editable: this.registrosEditables
        }
      }
    })
  }

  validarVolver() {
    if ( this.arrNotasPorEnviar.length === 0 ) {
      this.volverAPortal()
    } else {
      document.getElementById('btn-modal-cambios-pendientes')?.click()
    }
  }

  mostrarAlertaExito(texto: string) {
    this.alertaExito = texto
    setTimeout(() => {
      this.alertaExito = ''
    }, 3000);
  }

  mostrarInfoModal(titulo: string, texto: string) {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }

  getHeaderIndexByKey(valor: string) {
    const index: any = this.tablaCalificaciones?.headers.findIndex((header: ITablaHeaders) => header.valor === valor)
    return index
  }

  modificarCalificacion(indexBody: number, indexRow: number, calificacion: any, event: any, focusOut: boolean = false) {
    if ( calificacion.valor !== event.target.value ) {
      calificacion.nuevoValor = event.target.value
      calificacion.timestamp = Date.now()
      this.registrosModificados = true

      if ( focusOut ) {
        this.sendSocketInfo(indexBody, calificacion, indexRow)
      }
    }
  }

  modificarAnotaciones(indexBody: number, indexRow: number, calificacion: any, event: any) {
    this.modificarCalificacion(indexBody, indexRow, calificacion, event)
  }

  resetTimestampCalificaciones() {
    this.tablaCalificaciones?.body.forEach(
      (body: ITablaBody) => {
        body.row.forEach((row: ITablaBodyRow, rowIndex) => {
          if ( row.hasOwnProperty("timestamp") ) {
            row.timestamp = null
          }
        })
      }
    )
  }

  guardarCalificaciones(autoguardado: boolean = false, redirect: boolean = false) {
    if ( this.arrNotasPorEnviar.length > 0 ) {
      this.reenviarNotasPendientes()
    } else {
      this.mostrarAlertaExito('Los cambios se han guardado correctamente.')
    }
  }

  allowNumericDigitsOnlyOnKeyUp(e: any, indexBody: number, i: number, row: any) {
    this._utilsFn.allowNumericDigitsOnlyOnKeyUp(e, indexBody, i, row)
    this.modificarCalificacion(indexBody, i, row, e)
	}

  keyUpCalificacion(e: any, indexBody: number, i: number, row: any) {
    setTimeout(() => {
      e.target.value = e.target.value.replace(/[^\d,]/g, '')
      if ( e.target.value.length > 3 ) {
        e.target.value = e.target.value.substring(0, 3)
        this.modificarCalificacion(indexBody, i, row, e)
      }
      if ( e.target.value.length === 2 && !e.target.value.includes(',') ) {
        e.target.value = e.target.value[0] + ',' + e.target.value[1]
        this.modificarCalificacion(indexBody, i, row, e)
      }

      if ( (e.target.value.length === 3 && +e.target.value[0] > 7) || (e.target.value.length === 3 && e.target.value[0] === '7' && e.target.value[2] !== '0' ) ) {
        e.target.value = '0,0'
        this.modificarCalificacion(indexBody, i, row, e)
      }
    }, 300);
  }

  focusOut(e: any, indexBody: number, i: number, row: any, tipoAnotacion: boolean = false) {
    if ( !tipoAnotacion ) {
      this._utilsFn.focusOut(e, indexBody, i, row)
    }
    this.modificarCalificacion(indexBody, i, row, e, true)
  }

}
